import { request } from '../request'

//结算处获取当前用户已审批及待审批任务列表o
export function getApproveTask(data) {
  return request({
    url: '/award/statement/getApproveTask',
    method: 'get',
    params: data
  })
}